import type { DatadogRumConfig } from "@softmax/web-features/telemetry/rum";

const revision = import.meta.env.VITE_GIT_COMMIT || "development";

const applicationId = import.meta.env.VITE_DD_RUM_APP_ID;

const clientToken = import.meta.env.VITE_DD_CLIENT_TOKEN;

export const publicConfig = {
  revision,
  datadogRum:
    applicationId && clientToken
      ? ({
          applicationId,
          clientToken,
          site: import.meta.env.VITE_DD_SITE || "datadoghq.com",
          service: "softmax-com",
          environment: import.meta.env.VITE_SOFTMAX_ENV,
          version: revision,
        } satisfies DatadogRumConfig)
      : null,
};
